import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDocumentTitle } from '../../hooks/useDocumentTitle'
import { MainLayout } from '../../components/layouts/MainLayout'
import { CheckCircle, ArrowRight } from 'lucide-react'

const PENDING_APPLY_KEY = 'pending_apply'

export function EnrollmentSuccessPage() {
  useDocumentTitle('申込完了')
  const navigate = useNavigate()

  useEffect(() => {
    // pending_applyをクリア
    sessionStorage.removeItem(PENDING_APPLY_KEY)
  }, [])

  return (
    <MainLayout>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center">
          <CheckCircle className="mx-auto h-16 w-16 text-green-600 mb-6" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4">申込が完了しました</h1>
          <p className="text-lg text-gray-600 mb-8">
            ご登録いただいたメールアドレスに確認メールを送信しました。
            <br />
            マイページから講座の受講を開始できます。
          </p>

          <div className="space-y-4">
            <button
              onClick={() => navigate('/mypage')}
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition font-medium"
            >
              マイページへ
              <ArrowRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-3">次のステップ</h2>
          <ol className="list-decimal list-inside space-y-2 text-sm text-blue-800">
            <li>マイページで受講中の講座を確認</li>
            <li>講座のレッスンを順番に受講</li>
            <li>全レッスン完了後、試験に挑戦</li>
            <li>合格後、認定証を取得</li>
          </ol>
        </div>
      </div>
    </MainLayout>
  )
}
